import SeoHead from '../../components/SeoHead';
import useDynamicPages from "../../hooks/useDynamicPages";
import { DynamicPageSeo } from '../../ui/DynamicPageSeo';
import { Collection } from "@sourceflow-uk/sourceflow-sdk"
import SubBanner from '../../components/SubBanner';
import SimplePage from '../../components/SimplePage';
import Header from '../../components/MainHeader';
import { getDynamicPageStaticProps } from "../../functions/getDynamicPageStaticProps";
import { BuilderContentBlocks } from '../../ui/BuilderContentBlocks';

export default function simplePage({
    page, data, seo, isBuilder = false, prefix, title, canonical
}) {
    return (
        <>
          {isBuilder ? (
            <>
              <DynamicPageSeo
                  {...seo}
                  title={seo?.title.length > 0 ? seo.title : title}
                  canonical={seo?.canonical.length > 0 ? seo.canonical : canonical}
              />
              <Header />
              <BuilderContentBlocks data={data} prefix={prefix} />
            </>
          ) : (
            <>
            <Header />
            <SeoHead
                // site_name={`Driving Force`}
                page_name={`${page.title} | Gap Personnel`}
                // description={``}
                canonical_link={`/${page.url_slug}/`}
            />
            <SubBanner
                global={global}
                pathPrefix={`${page.url_slug}_page.sub_banner`}
                customClass={`mb-5 primary-banner`}
                buttonTitle={`Employers`}
                buttonLink={`/who-we-are/`}
                heading={`${page.title}`}
            />
            <SimplePage
                global={global}
                pathPrefix={`${page.url_slug}_page.content`}
                page={page}
                customClass={`simple-page`}
            />
            </>
          )}
        </>
    );
}

export async function getStaticProps({ params: { url_slug } }) {
  const slugParts = Array.isArray(url_slug) ? url_slug : [url_slug].filter(Boolean);
  const slug = slugParts.join("/");

  // 1. Check if it's a Builder page
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const dynamicPages = useDynamicPages();
  const builderPage = dynamicPages.find((p) => p.url_slug === slug);

  if (builderPage?.is_draft === true) {
    return { notFound: true };
  }

  if (builderPage) {
    const builderProps = await getDynamicPageStaticProps({ page: builderPage, url_slug: slug });
    return {
      props: {
          ...builderProps.props,
          isBuilder: true, // ensure isBuilder is passed
      },
    };
  }
  
  const page = (await Collection('simple_pages')).getJsonItem(slug, 'url_slug');

  return {
      props: { page },
  }
}

export async function getStaticPaths() {
  // 1. Builder pages
  // eslint-disable-next-line react-hooks/rules-of-hooks
  const builderPages = useDynamicPages();
  const builderPaths = builderPages.map((i) => ({
    params: { url_slug: i.url_slug.split("/").filter(Boolean) },
  }));

  // 2. Static pages — catch-all routes require url_slug as an array
  const pagePaths = ((await Collection('simple_pages')).getPaths('url_slug')).map(({ params }) => ({
    params: { url_slug: String(params.url_slug).split('/').filter(Boolean) },
  }));

  return {
      paths: [...builderPaths, ...pagePaths],
      fallback: false
  }
}